import { useMotionValue } from 'framer-motion';
import React from 'react';
import Sequence from '../../components/sequence';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';
import Visibility from '../../components/Visibility';
import { AppContext } from '../../Context';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 24 });

export function OS() {
  const [mobile, setMobile] = React.useState(false);
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [frozen, freeze] = React.useState(true);
  const [index, setIndex] = React.useState(-1);
  const [height, setHeight] = React.useState(0);
  const progress = useMotionValue(0);

  const frame_length = React.useMemo(() => {
    return mobile ? 91 : 92;
  }, [mobile]);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, width, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      progress.set(percentagePassed);
      const i = pureTrans(percentagePassed, [0, 0.6], [0, frame_length - 1], 0);
      setIndex(i);
      setMobile(width <= 750);
      setHeight(height);
    },
    [progress, freeze, setIndex, setHeight, frame_length, setMobile]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = React.useMemo(() => {
    return getSeqFrames({
      prefix: 'os',
      mobile,
      webpSupport: false,
      len: frame_length
    });
  }, [webpSupport, mobile, frame_length]);

  const onFramesLoaded = React.useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const anchorY = React.useMemo(() => {
    const top = 0.6 * height;
    return top;
  }, [height]);

  const seqReady = !frozen && webpDetectionFinished;
  return (
    <Visibility fireOnMount offset={[-1000, 1000]} onUpdate={handleUpdate} className="page-section section-os inverted" data-track={track}>
      <div id="origin-os" style={{ position: 'absolute', top: anchorY }} />
      <div className="sticky-content">
        <div className="section-background">
          <div className="sequence-wrapper">
            <Sequence name="os" current={index} frames={frames} active={seqReady} onload={onFramesLoaded} />
            <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
